import { JSONSchema6 } from "json-schema";

const completeCheckoutSessionSchema: JSONSchema6 = {
    title: "CompleteCheckoutSession",
    description: "Complete Checkout Session after the buyer returns to checkoutResultReturnUrl to finalize the paymentIntent. The chargeAmount in the request must match the Checkout Session object paymentDetails.chargeAmount to verify the transaction amount. This request returns HTTP 202 (Accepted) status if canHandlePendingAuthorization was set to true and the authorization is still pending. If the authorization result has been determined, this request will return a HTTP 200 (OK) status (https://restfulapi.net/http-status-200-ok) if the authorization was successful or a 4xx/5xx response if authorization failed.",
    properties: {
        "header": {
            type: "object",
            properties: {
                "x-amz-pay-idempotency-key": {
                    title: "x-amz-pay-idempotency-key",
                    type: "string"
                },
                "x-amz-pay-simulation-code": {
                    title: "x-amz-pay-simulation-code",
                    type: "string"
                }
            },
            required: ["x-amz-pay-idempotency-key"]
        },
        "pathParam": {
            title: "checkoutSessionId",
            type: "string"
        },
        "payload": {
            type: "object",
            properties: {
                "chargeAmount": {
                    title: "Charge Amount",
                    type: "object",
                    properties: {
                        "amount": {
                            type: "string"
                        },
                        "currencyCode": {
                            type: "string",
                            enum: ["", "AUD", "GBP", "DKK", "EUR", "HKD", "JPY", "NZD", "NOK", "ZAR", "SEK", "CHF", "USD"]
                        }
                    },
                },
                "totalOrderAmount": {
                    title: "Total Order Amount",
                    type: "object",
                    properties: {
                        "amount": {
                            type: "string"
                        },
                        "currencyCode": {
                            type: "string",
                            enum: ["", "AUD", "GBP", "DKK", "EUR", "HKD", "JPY", "NZD", "NOK", "ZAR", "SEK", "CHF", "USD"]
                        }
                    }
                },
            },
        }
    },
    required: ["header", "pathParam"]
}

export default completeCheckoutSessionSchema
